import { render, staticRenderFns } from "./newsletters.vue?vue&type=template&id=7b18f1f5&"
import script from "./newsletters.vue?vue&type=script&lang=js&"
export * from "./newsletters.vue?vue&type=script&lang=js&"
import style0 from "./newsletters.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports